{
  "R": [
    0, 9, 24, 33, 40, 46, 52, 57, 62, 66, 70, 74, 78, 81, 85, 88, 91, 94, 98,
    101, 103, 106, 109, 112, 114, 117, 119, 121, 124, 126, 128, 130, 133, 135,
    137, 139, 141, 143, 145, 147, 149, 151, 153, 155, 157, 159, 161, 163, 164,
    166, 168, 169, 171, 172, 174, 175, 177, 178, 180, 181, 183, 184, 186, 187,
    189, 190, 191, 193, 194, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205,
    206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220,
    221, 222, 222, 223, 224, 224, 225, 226, 226, 227, 228, 228, 229, 229, 230,
    231, 231, 232, 233, 233, 234, 234, 235, 235, 236, 236, 236, 237, 237, 237,
    238, 238, 238, 239, 239, 239, 240, 240, 240, 241, 241, 241, 242, 242, 242,
    243, 243, 243, 243, 243, 243, 243, 243, 244, 244, 244, 244, 244, 244, 244,
    244, 244, 244, 244, 245, 245, 245, 245, 245, 245, 245, 245, 245, 245, 245,
    245, 245, 245, 245, 245, 244, 244, 244, 244, 244, 244, 244, 244, 244, 244,
    244, 244, 244, 244, 244, 243, 243, 243, 243, 243, 243, 243, 243, 243, 243,
    243, 243, 242, 242, 242, 242, 242, 242, 242, 242, 241, 242, 242, 242, 242,
    242, 242, 242, 242, 242, 242, 242, 242, 242, 242, 242, 242, 242, 242, 242,
    242, 242, 242, 242, 243, 243, 244, 244, 245, 246, 246, 247, 247, 248, 249,
    249, 250, 250, 251, 251, 252, 252, 253, 253, 254, 254, 254
  ],
  "G": [
    42, 41, 41, 41, 40, 40, 40, 39, 39, 39, 38, 38, 37, 37, 36, 36, 35, 35, 34,
    34, 33, 32, 32, 31, 30, 30, 30, 30, 29, 29, 29, 29, 28, 28, 28, 27, 27, 27,
    26, 26, 26, 25, 25, 25, 24, 24, 24, 24, 24, 25, 25, 26, 27, 27, 28, 28, 29,
    30, 30, 31, 31, 32, 33, 33, 34, 34, 35, 36, 36, 37, 38, 39, 40, 42, 43, 44,
    45, 47, 48, 49, 50, 51, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66,
    68, 69, 71, 72, 73, 75, 76, 77, 79, 80, 81, 83, 84, 85, 87, 88, 89, 90, 92,
    93, 94, 95, 97, 98, 100, 101, 102, 104, 105, 107, 108, 109, 111, 112, 113,
    115, 116, 117, 119, 120, 121, 122, 124, 125, 126, 128, 129, 130, 132, 133,
    134, 136, 137, 138, 140, 141, 142, 144, 145, 146, 147, 149, 150, 151, 153,
    154, 155, 156, 158, 159, 160, 161, 163, 164, 165, 167, 168, 169, 170, 172,
    173, 174, 175, 176, 178, 179, 180, 181, 183, 184, 185, 186, 187, 189, 190,
    191, 192, 193, 194, 196, 197, 198, 199, 200, 201, 203, 204, 205, 206, 207,
    208, 209, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223,
    224, 225, 226, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 238,
    239, 240, 241, 241, 242, 243, 244, 244, 245, 246, 247, 248, 248, 249, 250,
    251, 251, 252, 253, 254, 255
  ],
  "B": [
    167, 167, 166, 166, 166, 165, 165, 165, 164, 164, 164, 163, 163, 162, 162,
    162, 161, 161, 161, 160, 160, 160, 159, 159, 158, 158, 157, 157, 156, 155,
    155, 154, 154, 153, 153, 152, 151, 151, 150, 150, 149, 149, 148, 147, 147,
    146, 146, 145, 144, 144, 143, 143, 142, 141, 141, 140, 139, 139, 138, 137,
    137, 136, 135, 135, 134, 133, 133, 132, 131, 131, 130, 130, 129, 128, 128,
    127, 127, 126, 125, 125, 124, 124, 123, 123, 122, 121, 121, 120, 119, 119,
    118, 118, 117, 116, 116, 116, 115, 115, 114, 114, 113, 113, 113, 112, 112,
    111, 111, 110, 110, 109, 109, 109, 108, 108, 107, 107, 106, 106, 106, 106,
    106, 105, 105, 105, 105, 105, 105, 105, 104, 104, 104, 104, 104, 103, 103,
    103, 103, 103, 102, 102, 102, 103, 103, 103, 103, 104, 104, 104, 104, 104,
    105, 105, 105, 105, 106, 106, 106, 106, 106, 107, 107, 107, 107, 108, 108,
    109, 110, 111, 111, 112, 113, 113, 114, 115, 115, 116, 117, 117, 118, 119,
    120, 120, 121, 122, 122, 123, 124, 125, 126, 128, 129, 130, 131, 132, 134,
    135, 136, 137, 138, 140, 141, 142, 143, 144, 146, 147, 148, 149, 150, 152,
    153, 155, 157, 158, 160, 162, 163, 165, 167, 168, 170, 172, 173, 175, 177,
    178, 180, 182, 183, 185, 187, 188, 190, 193, 196, 199, 201, 204, 207, 210,
    212, 215, 218, 221, 224, 226, 229, 232, 235, 238, 240, 243, 246, 249, 252,
    255
  ],
  "A": [
    0, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64
  ],
  "I": [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
    40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
    59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
    78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96,
    97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
    113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
    128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142,
    143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157,
    158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172,
    173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187,
    188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
    203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
    218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
    233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247,
    248, 249, 250, 251, 252, 253, 254, 255
  ]
}
